import { render, staticRenderFns } from "./ChangelogCreateModal.vue?vue&type=template&id=817ad7f0"
import script from "./ChangelogCreateModal.vue?vue&type=script&lang=js"
export * from "./ChangelogCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports